
































import Vue from "vue";
import ViewItem from "@/components/ViewItem.vue";
import ContentWithSidebar from "@/components/ContentWithSidebar.vue";

const HEADINGS: Record<string, string> = {
    hotseat: "Hotseat games",
    link: "Fun links",
    poll: "Polls",
    newsitem: "News",
    goggle: "Goggles",
    qwokpost: "Qwok Games posts",
    universe: "The GWTP Universe",
};

export default Vue.extend({

    components: {
        ViewItem,
        ContentWithSidebar,
    },

    data() {
        return {
            heading: null as string|null,
        };
    },

    computed: {
        showComicModeOption(): boolean {
            return this.$route.query.limit === '1' && this.$route.query.types === 'strip';
        },
        items(): any[] { return this.$store.state.items; },
        forwardUrl() { return this.$store.state.forwardUrl; },
        backUrl() { return this.$store.state.backUrl; },
    },

    mounted() {
        this.loadData();

        const isQwokPosts = this.$route.query.types === 'qwokpost' || this.$route.query.types === '19';
        document.body.classList.remove(isQwokPosts ? 'gwtp' : 'qwok');
        document.body.classList.add(isQwokPosts ? 'qwok' : 'gwtp');
    },

    watch: {
        $route(value: string, oldValue: string) {
            this.loadData();
        },
    },

    beforeDestroy() {
        document.body.classList.remove('qwok');
        document.body.classList.add('gwtp');
    },

    methods: {
        toggleComicMode() {
            this.$store.commit('toggleComicMode');
        },

        loadData() {
            const types = this.$route.query.types;
            this.heading = types in HEADINGS ? HEADINGS[types] : null;

            const params = Object.assign({ limit: 5 }, this.$route.query);
            const isQwokPosts = this.$route.query.types === 'qwokpost' || this.$route.query.types === '19';
            this.$store.dispatch('updateItems', { params, isQwokPosts });
        },
    },
});
